import { ErpSpuItemParam, ErpSpuQueryResult, StyleCodeCheckVo, StyleCodeCheckResult, GetProcessUsingGet2Params, ExcelImportStatus, QueryErpOfflineSuppliersUsingGetParams, ErpPurchaserResult, ErpCategoryResult, ErpSpuImportContext, QueryCategoryParam, ErpCategoryResultVo, ErpSkuImportContext1, ItemCodeCheckResult } from '@servicesTypings/goodsRequest'
import { goodsRequest } from '@/utils/request'
import { getCacheService } from '@/utils/requestUtils'

// 查询ERP商品
/**
 * ERP聚经销商品查询
 */
export function queryTable(data: ErpSpuItemParam): API.Res<ErpSpuQueryResult[]> {
    return goodsRequest.post('/erp/spuImport/queryErpSpuPage', { data })
}

// 查询选中款号是否存在重复
/**
 * 查询选中款号是否存在重复
 */
export function checkRepeatStyleCode(data: StyleCodeCheckVo): API.Res<StyleCodeCheckResult> {
    return goodsRequest.post('/erp/spuImport/checkRepeatStyleCode', { data })
}

// 查询ERP商品导入进度
/**
 * 获取进度条
 */
export function queryProcess(params: GetProcessUsingGet2Params): API.Res<ExcelImportStatus> {
    return goodsRequest.get('/erpGoods/getProcess', { params })
}

// 查询ERP供应商列表
/**
 * 线下自主供应商搜索列表
 */
export function queryErpOfflineSuppliers(
    params: QueryErpOfflineSuppliersUsingGetParams
): API.Res<ErpPurchaserResult[]> {
    return goodsRequest.get('/erp/spuImport/queryErpOfflineSuppliers', { params })
}

// 查询ERP商品品牌列表
export function queryErpBrand(params) {
    const goodsRequestCache = getCacheService(goodsRequest)
    return goodsRequestCache.get('/erp/spuImport/queryErpBrand', {
        params
    })
}

// 查询ERP商品分类列表
/**
 * 商品分类列表
 */
export function queryErpCategory(): API.Res<ErpCategoryResult[]> {
    return goodsRequest.get('/erp/spuImport/queryErpCategory')
}

// 以下导入操作
/**
 * @description:  批量导入
 */
/**
 * ERP聚经销商品导入
 */
export function batchImport(data: ErpSpuImportContext): API.Res<string> {
    return goodsRequest.post('/erp/spuImport/erpSpuItemImport', { data })
}

// 查询 erp 商品分类
/**
 * 查询ERP类目
 */
export function erpQueryCategory(data: QueryCategoryParam): API.Res<ErpCategoryResultVo[]> {
    return goodsRequest.post('/erp/category/queryCategory', { data })
}

/**
* 参数都是必填 
*/
export function checkRepeatByQueryUsingPOST(data: ErpSkuImportContext1): API.Res<ItemCodeCheckResult> {
    return goodsRequest.post('/erpGoods/import/checkRepeatByQuery', { data })
}
